import Navbar from './Navbar';
import SiteRoutes from './SiteRoutes';
import './App.css';
import React, { useState, createContext, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Cookies from 'js-cookie';


export const AppContext = createContext(null)

const loadState = (key, defaultValue) => {
  const savedState = localStorage.getItem(key);
  return savedState ? JSON.parse(savedState) : defaultValue;
};

function App() {

  const [user, setUser] = useState(() => {
    const savedUser = Cookies.get('user');
    return savedUser ? JSON.parse(savedUser) : null;
  });

  const [isLogged, setIsLogged] = useState(() => {
    const loggedStatus = Cookies.get('isLogged');
    return loggedStatus === 'true'; // Cookies store everything as strings
  });

  const location = useLocation();

  const hideNavbarRoutes = [
    "/invitation/confirm/:uuid",
    "/invitation/general/:slug"
  ];
  
  const shouldHideNavbar = hideNavbarRoutes.some((route) =>
    location.pathname.startsWith(route.replace(/:\w+/, ""))
  );
  

  
  return (
    <div className="App">
      <AppContext.Provider value={{ user, setUser, isLogged, setIsLogged }}>
      {!shouldHideNavbar && <Navbar />}
      <div>
        <SiteRoutes />
      </div>
      </AppContext.Provider>
    </div>
  );
}

export default App;
